export function NonSpecializedMedicalAttendances() {
	return <div>MedicalAttendancesByCidTable</div>;
}
